import { createContext } from 'react';
import { SearchContextState } from './SearchContext.types';

// PENDING: add the CruiseSearchContext search portion to this context 
//          keep adding props to the SearchContextState
export const initialSearchContextState: SearchContextState = {
	results: [],
  total: 0,
  isSearching: false,
};

export const SearchContext = createContext<SearchContextState>(initialSearchContextState);